import React from "react";
import { ResponsiveImage } from "~assets/frontend/elements/responsive-image/ResponsiveImage";
import { TextLink } from "~assets/frontend/elements/text-link/TextLink";
export const SearchAd = ({ keywords, headline, text, imageStruct, href }) => {
    const sizes = {
        extraSmall: {
            w: 256,
            h: 165,
        },
        small: {
            w: 264,
            h: 176,
        },
        medium: {
            w: 318,
            h: 212,
        },
        large: {
            w: 278,
            h: 185,
        },
        extraLarge: {
            w: 216,
            h: 144,
        },
    };
    return (React.createElement("div", { className: "grid grid-cols-2 gap-x-12 md:gap-x-36 xl:grid-cols-4" },
        imageStruct && React.createElement(ResponsiveImage, Object.assign({}, imageStruct, { sizes: sizes, caption: "", copyright: "" })),
        React.createElement("div", { className: "xl:col-span-3" },
            href && (React.createElement("h3", null,
                React.createElement(TextLink, { tracking: {
                        name: "ui",
                        payload: {
                            ui_component: "frm-search",
                            ui_function: "navigate",
                            ui_action: "searchAd",
                            ui_target: headline,
                        },
                    }, _name: "TextLinkStruct", _id: "", label: headline, href: href, icon: { position: "end", identifier: "icon-arrow-right", className: "ml-6" } }))),
            !href && React.createElement("h3", null, headline),
            React.createElement("div", { className: "text-black-40", dangerouslySetInnerHTML: { __html: text } }))));
};
